import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle, FaTrashAlt, FaTimes, FaCheck } from 'react-icons/fa';
import './ConfirmationModal.css';

function ConfirmationModal({
    show,
    handleClose,
    onConfirm,
    title = 'Confirm Action',
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'danger', // 'danger', 'warning', 'info', 'success'
    icon = null,
    isLoading = false,
    children = null,
    confirmDisabled = false
}) {
    const getIconComponent = () => {
        if (icon) return icon;
        switch (variant) {
            case 'danger':
                return <FaTrashAlt />;
            case 'warning':
                return <FaExclamationTriangle />;
            case 'success':
                return <FaCheck />;
            default:
                return <FaExclamationTriangle />;
        }
    };

    const getVariantClass = () => {
        switch (variant) {
            case 'danger':
                return 'confirmation-modal-danger';
            case 'warning':
                return 'confirmation-modal-warning';
            case 'info':
                return 'confirmation-modal-info';
            case 'success':
                return 'confirmation-modal-success';
            default:
                return 'confirmation-modal-danger';
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className={`confirmation-modal ${getVariantClass()}`}
            backdrop="static"
        >
            <Modal.Body className="confirmation-modal-body">
                <button
                    className="confirmation-modal-close"
                    onClick={handleClose}
                    aria-label="Close"
                >
                    <FaTimes />
                </button>

                <div className={`confirmation-modal-icon ${variant}`}>
                    {getIconComponent()}
                </div>

                <h4 className="confirmation-modal-title">{title}</h4>

                <p className="confirmation-modal-message">{message}</p>

                {children && <div className="confirmation-modal-children">{children}</div>}

                <div className="confirmation-modal-actions">
                    <Button
                        variant="outline-secondary"
                        onClick={handleClose}
                        className="confirmation-modal-btn cancel"
                        disabled={isLoading}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant={variant}
                        onClick={onConfirm}
                        className="confirmation-modal-btn confirm"
                        disabled={isLoading || confirmDisabled}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Processing...
                            </>
                        ) : (
                            confirmText
                        )}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ConfirmationModal;
